var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", { staticClass: "clearfix" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "el-form",
                { attrs: { size: "small", "label-width": "100px" } },
                [
                  _vm.checkPermi(["admin:order:status:num"])
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "订单状态：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.seachList },
                              model: {
                                value: _vm.tableFrom.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "status", $$v)
                                },
                                expression: "tableFrom.status",
                              },
                            },
                            [
                              _c(
                                "el-radio-button",
                                { attrs: { label: "all" } },
                                [
                                  _vm._v(
                                    "全部 " +
                                      _vm._s(
                                        "(" + _vm.orderChartType.all
                                          ? _vm.orderChartType.all
                                          : 0 + ")"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "unPaid" } },
                                [
                                  _vm._v(
                                    "未支付 " +
                                      _vm._s(
                                        "(" + _vm.orderChartType.unPaid
                                          ? _vm.orderChartType.unPaid
                                          : 0 + ")"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "notShipped" } },
                                [
                                  _vm._v(
                                    "未发货 " +
                                      _vm._s(
                                        "(" + _vm.orderChartType.notShipped
                                          ? _vm.orderChartType.notShipped
                                          : 0 + ")"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "spike" } },
                                [
                                  _vm._v(
                                    "待收货 " +
                                      _vm._s(
                                        "(" + _vm.orderChartType.spike
                                          ? _vm.orderChartType.spike
                                          : 0 + ")"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.bizType == 3
                                ? _c(
                                    "el-radio-button",
                                    { attrs: { label: "bargain" } },
                                    [
                                      _vm._v(
                                        "待归还 " +
                                          _vm._s(
                                            "(" + _vm.orderChartType.bargain
                                              ? _vm.orderChartType.bargain
                                              : 0 + ")"
                                          )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "el-radio-button",
                                    { attrs: { label: "bargain" } },
                                    [
                                      _vm._v(
                                        "待评价 " +
                                          _vm._s(
                                            "(" + _vm.orderChartType.bargain
                                              ? _vm.orderChartType.bargain
                                              : 0 + ")"
                                          )
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "complete" } },
                                [
                                  _vm._v(
                                    "交易完成 " +
                                      _vm._s(
                                        "(" + _vm.orderChartType.complete
                                          ? _vm.orderChartType.complete
                                          : 0 + ")"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "toBeWrittenOff" } },
                                [
                                  _vm._v(
                                    "待核销 " +
                                      _vm._s(
                                        "(" + _vm.orderChartType.toBeWrittenOff
                                          ? _vm.orderChartType.toBeWrittenOff
                                          : 0 + ")"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "refunding" } },
                                [
                                  _vm._v(
                                    "退款中 " +
                                      _vm._s(
                                        "(" + _vm.orderChartType.refunding
                                          ? _vm.orderChartType.refunding
                                          : 0 + ")"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "refunded" } },
                                [
                                  _vm._v(
                                    "已退款 " +
                                      _vm._s(
                                        "(" + _vm.orderChartType.refunded
                                          ? _vm.orderChartType.refunded
                                          : 0 + ")"
                                      )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "width100", attrs: { label: "时间选择：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "mr20",
                          attrs: { type: "button", size: "small" },
                          on: {
                            change: function ($event) {
                              return _vm.selectChange(_vm.tableFrom.dateLimit)
                            },
                          },
                          model: {
                            value: _vm.tableFrom.dateLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "dateLimit", $$v)
                            },
                            expression: "tableFrom.dateLimit",
                          },
                        },
                        _vm._l(_vm.fromList.fromTxt, function (item, i) {
                          return _c(
                            "el-radio-button",
                            { key: i, attrs: { label: item.val } },
                            [_vm._v(_vm._s(item.text))]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          size: "small",
                          type: "daterange",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "width100", attrs: { label: "订单号：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入订单号",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.tableFrom.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "orderNo", $$v)
                            },
                            expression: "tableFrom.orderNo",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.seachList },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { staticClass: "width100" }),
                  _vm._v(" "),
                  _vm.myCustomConfig.tenantKey == "shucaipifa"
                    ? _c(
                        "el-button",
                        {
                          staticStyle: {
                            position: "absolute",
                            right: "50px",
                            top: "30px",
                          },
                          attrs: { type: "warning", size: "small" },
                          on: { click: _vm.shucaipifalirunjisuan },
                        },
                        [_vm._v("利润计算")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt20" }),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _vm.canPrintOrder
            ? _c(
                "div",
                { staticClass: "mb10" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-printer",
                        disabled: !_vm.selectionList.length,
                        loading: _vm.batchPrintLoading,
                      },
                      on: { click: _vm.onBatchOrderPrint },
                    },
                    [_vm._v("批量打印")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.configReady
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  key: _vm.tableKey,
                  ref: "orderTable",
                  staticClass: "table",
                  attrs: {
                    border: true,
                    data: _vm.tableData.data,
                    size: "mini",
                    "highlight-current-row": "",
                    "header-cell-style": { fontWeight: "bold" },
                    "row-key": function (row) {
                      return row.orderNo
                    },
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _vm.canPrintOrder
                    ? _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "48",
                          align: "center",
                          fixed: "left",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商城订单号", "min-width": "210" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", {
                                staticStyle: { display: "block" },
                                domProps: {
                                  textContent: _vm._s(scope.row.orderNo),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.deleted,
                                      expression: "scope.row.deleted",
                                    },
                                  ],
                                  staticStyle: {
                                    color: "#ED4014",
                                    display: "block",
                                  },
                                },
                                [_vm._v("用户已删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3361523582
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "微信商户订单号", "min-width": "210" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", {
                                staticStyle: { display: "block" },
                                domProps: {
                                  textContent: _vm._s(scope.row.outTradeNo),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.deleted,
                                      expression: "scope.row.deleted",
                                    },
                                  ],
                                  staticStyle: {
                                    color: "#ED4014",
                                    display: "block",
                                  },
                                },
                                [_vm._v("用户已删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2178218040
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderTypeText",
                      label: "订单类型",
                      "min-width": "140",
                    },
                  }),
                  _vm._v(" "),
                  _vm.myCustomConfig.tenantKey == "shucaipifa"
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "user",
                          label: "店铺名称",
                          "min-width": "110",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.user &&
                                          scope.row.user.companyName
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3369508051
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bizType == 3
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "leaseOrderInfo.payDepositPrice",
                          label: "押金金额",
                          "min-width": "100",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bizType == 3
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "leaseOrderInfo.leasePrice",
                          label: "租金金额",
                          "min-width": "100",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bizType == 3
                    ? _c("el-table-column", {
                        attrs: { label: "租赁日期", "min-width": "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.leaseOrderInfo.startDate
                                      ) +
                                      " 至 " +
                                      _vm._s(scope.row.leaseOrderInfo.endDate) +
                                      "（" +
                                      _vm._s(scope.row.leaseOrderInfo.days) +
                                      "天)\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2856283222
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bizType == 3
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "leaseOrderInfo.returnTime",
                          label: "归还日期",
                          "min-width": "100",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "receiverName",
                      label: "收货人",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _vm.myCustomConfig.mallType == 2
                    ? _c("el-table-column", {
                        attrs: { label: "文档信息", "min-width": "300" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.productList &&
                                  scope.row.productList.length
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          scope.row.productList,
                                          function (val, i) {
                                            return _c(
                                              "div",
                                              {
                                                key: i,
                                                staticClass: "tabBox ",
                                                staticStyle: {
                                                  "flex-wrap": "inherit",
                                                  "margin-bottom": "8px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "demo-image__preview mr10",
                                                    staticStyle: {
                                                      width: "200px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticStyle: {
                                                          display:
                                                            "inline-block",
                                                          "max-width": "100%",
                                                          "vertical-align":
                                                            "middle",
                                                          cursor: "pointer",
                                                          color: "#00afff",
                                                        },
                                                        attrs: {
                                                          title:
                                                            _vm.getFileName(
                                                              val.info.extData
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleDownload(
                                                              [val],
                                                              scope.row
                                                                .receiverName,
                                                              scope.row.orderNo
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.getFileName(
                                                                val.info.extData
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text_overflow",
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                      width: "200px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tabBox_tit mr10",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n            " +
                                                            _vm._s(
                                                              val.info
                                                                .productName
                                                            ) +
                                                            " | " +
                                                            _vm._s(
                                                              val.info.sku ||
                                                                "-"
                                                            ) +
                                                            "\n          "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "140px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.getWrapperName(
                                                            val.info.extData
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "60px",
                                                    },
                                                  },
                                                  [
                                                    _vm.getCustomInfo(
                                                      val.info.extData
                                                    ).currentBg ||
                                                    _vm.getCustomInfo(
                                                      val.info.extData
                                                    ).currentBgWithText
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              margin: "0 10px",
                                                            },
                                                          },
                                                          [
                                                            _vm.getCustomInfo(
                                                              val.info.extData
                                                            ).currentBgWithText
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      target:
                                                                        "_blank",
                                                                      href: _vm.getCustomInfo(
                                                                        val.info
                                                                          .extData
                                                                      )
                                                                        .currentBgWithText,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "50px",
                                                                            height:
                                                                              "50px",
                                                                            "object-fit":
                                                                              "cover",
                                                                          },
                                                                        attrs: {
                                                                          src: _vm.getCustomInfo(
                                                                            val
                                                                              .info
                                                                              .extData
                                                                          )
                                                                            .currentBgWithText,
                                                                          "preview-src-list":
                                                                            [
                                                                              _vm.getCustomInfo(
                                                                                val
                                                                                  .info
                                                                                  .extData
                                                                              )
                                                                                .currentBgWithText,
                                                                            ],
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm.getCustomInfo(
                                                                  val.info
                                                                    .extData
                                                                ).currentBg
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      target:
                                                                        "_blank",
                                                                      href: _vm.getCustomInfo(
                                                                        val.info
                                                                          .extData
                                                                      )
                                                                        .currentBg,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "50px",
                                                                            height:
                                                                              "50px",
                                                                            "object-fit":
                                                                              "cover",
                                                                          },
                                                                        attrs: {
                                                                          src: _vm.getCustomInfo(
                                                                            val
                                                                              .info
                                                                              .extData
                                                                          )
                                                                            .currentBg,
                                                                          "preview-src-list":
                                                                            [
                                                                              _vm.getCustomInfo(
                                                                                val
                                                                                  .info
                                                                                  .extData
                                                                              )
                                                                                .currentBg,
                                                                            ],
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text_overflow",
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                      width: "180px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tabBox_pice",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "页数：" +
                                                            _vm._s(
                                                              _vm.getResourcePageCount(
                                                                val.info.extData
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tabBox_pice",
                                                        staticStyle: {
                                                          "margin-left": "10px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "缩印：" +
                                                            _vm._s(
                                                              _vm.parseLayout(
                                                                _vm.getCustomInfo(
                                                                  val.info
                                                                    .extData
                                                                ).layoutType
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text_overflow",
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tabBox_pice",
                                                        staticStyle: {
                                                          color: "red",
                                                          "font-weight": "bold",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "份数：" +
                                                            _vm._s(
                                                              val.info
                                                                .buyQuantity
                                                            ) +
                                                            "份"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3868476304
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.myCustomConfig.mallType == 2
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "printStatus",
                          label: "打印状态",
                          "min-width": "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.printStatus == 1
                                    ? _c("span", [_vm._v("待打印")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.printStatus == 2
                                    ? _c("span", [_vm._v("打印中")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.printStatus == 3
                                    ? _c("span", [_vm._v("已打印")])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1396500952
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.myCustomConfig.mallType == 1
                    ? _c("el-table-column", {
                        attrs: { label: "商品信息", "min-width": "400" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        trigger: "hover",
                                        placement: "right",
                                        "open-delay": 800,
                                      },
                                    },
                                    [
                                      scope.row.productList &&
                                      scope.row.productList.length
                                        ? _c(
                                            "div",
                                            {
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            _vm._l(
                                              scope.row.productList,
                                              function (val, i) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: i,
                                                    staticClass:
                                                      "tabBox acea-row row-middle",
                                                    staticStyle: {
                                                      "flex-wrap": "inherit",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "demo-image__preview mr10",
                                                      },
                                                      [
                                                        _c("el-image", {
                                                          attrs: {
                                                            src: val.info.image,
                                                            "preview-src-list":
                                                              [val.info.image],
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text_overflow",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tabBox_tit mr10",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                val.info
                                                                  .productName +
                                                                  " | "
                                                              ) +
                                                                _vm._s(
                                                                  val.info.sku
                                                                    ? val.info
                                                                        .sku
                                                                    : "-"
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.$selfUtil.isUsePriceBiz(
                                                          val.info.bizType
                                                        )
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tabBox_pice",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " ￥" +
                                                                    _vm._s(
                                                                      val.info
                                                                        .price
                                                                        ? val
                                                                            .info
                                                                            .price +
                                                                            " x " +
                                                                            val
                                                                              .info
                                                                              .buyQuantity
                                                                        : "-"
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        val.info.bizType == 2
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "tabBox_pice",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    val.info
                                                                      .pointsPrice +
                                                                      "积分" +
                                                                      " x " +
                                                                      val.info
                                                                        .buyQuantity
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.productList &&
                                      scope.row.productList.length
                                        ? _c(
                                            "div",
                                            { staticClass: "pup_card" },
                                            _vm._l(
                                              scope.row.productList,
                                              function (val, i) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: i,
                                                    staticClass:
                                                      "tabBox acea-row row-middle",
                                                    staticStyle: {
                                                      "flex-wrap": "inherit",
                                                    },
                                                  },
                                                  [
                                                    _c("div", {}, [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "tabBox_tit mr10",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              val.info
                                                                .productName +
                                                                " | "
                                                            ) +
                                                              _vm._s(
                                                                val.info.sku
                                                                  ? val.info.sku
                                                                  : "-"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "tabBox_pice",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              "￥" +
                                                                val.info.price
                                                                ? val.info
                                                                    .price +
                                                                    " x " +
                                                                    val.info
                                                                      .buyQuantity
                                                                : "-"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          997699870
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "payAmount",
                      label: "实际支付",
                      "min-width": "80",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "支付方式", "min-width": "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.payTypeStr)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1599512067
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "订单状态",
                      "min-width": "100",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                scope.row.refundStatus === 1 ||
                                scope.row.refundStatus === 2
                                  ? _c(
                                      "div",
                                      { staticClass: "refunding" },
                                      [
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                trigger: "hover",
                                                placement: "left",
                                                "open-delay": 800,
                                              },
                                            },
                                            [
                                              _c(
                                                "b",
                                                {
                                                  staticStyle: {
                                                    color: "#f124c7",
                                                  },
                                                  attrs: { slot: "reference" },
                                                  slot: "reference",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.statusStr.value
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "pup_card flex-column",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "退款原因：" +
                                                        _vm._s(
                                                          scope.row
                                                            .refundReasonUser
                                                        )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "备注说明：" +
                                                        _vm._s(
                                                          scope.row
                                                            .refundExplain
                                                        )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "退款时间：" +
                                                        _vm._s(
                                                          scope.row
                                                            .refundApplyTime
                                                        )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "acea-row" },
                                                    [
                                                      _vm._v(
                                                        "\n                            退款凭证：\n                            "
                                                      ),
                                                      scope.row.refundImages
                                                        ? _vm._l(
                                                            scope.row.refundImages.split(
                                                              ","
                                                            ),
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "demo-image__preview",
                                                                  staticStyle: {
                                                                    width:
                                                                      "35px",
                                                                    height:
                                                                      "auto",
                                                                    display:
                                                                      "inline-block",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-image",
                                                                    {
                                                                      attrs: {
                                                                        src: item,
                                                                        "preview-src-list":
                                                                          [
                                                                            item,
                                                                          ],
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display:
                                                                  "inline-block",
                                                              },
                                                            },
                                                            [_vm._v("无")]
                                                          ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                      ],
                                      2
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(scope.row.statusStr.value)),
                                    ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3871389857
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "下单时间",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      "min-width": "150",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.statusStr.key === "notShipped" &&
                              scope.row.refundStatus === 0
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: ["admin:order:send"],
                                          expression: "['admin:order:send']",
                                        },
                                      ],
                                      staticClass: "mr10",
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.sendOrder(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("发送货")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.statusStr.key === "toBeWrittenOff" &&
                              scope.row.payStatus == true &&
                              scope.row.refundStatus === 0
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: ["admin:order:write:update"],
                                          expression:
                                            "['admin:order:write:update']",
                                        },
                                      ],
                                      staticClass: "mr10",
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onWriteOff(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("立即核销")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-dropdown",
                                { attrs: { trigger: "click" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link" },
                                    [
                                      _vm._v("\n                更多"),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    [
                                      _vm.checkPermi(["admin:order:info"])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.onOrderDetails(
                                                    scope.row.orderNo
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("订单详情")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.checkPermi([
                                        "admin:order:status:list",
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.onOrderLog(
                                                    scope.row.orderNo
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("订单记录")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.checkPermi(["admin:order:mark"])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.onOrderMark(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("订单备注")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.checkPermi(["admin:order:mark"]) &&
                                      scope.row.orderStatus == 1
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.onOrderExpressNum(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("修改快递单号")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.refundStatus === 1 &&
                                      _vm.checkPermi([
                                        "admin:order:refund:refuse",
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.onOrderRefuse(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("拒绝退款")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.refundStatus === 1 &&
                                      _vm.checkPermi(["admin:order:refund"])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.onOrderRefund(
                                                    scope.row,
                                                    false
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("立即退款")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      ["xueyuexueju"].includes(
                                        _vm.myCustomConfig.tenantKey
                                      ) &&
                                      scope.row.refundStatus === 0 &&
                                      _vm.checkPermi(["admin:order:refund"])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.onOrderRefund(
                                                    scope.row,
                                                    true
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("后台发起退款")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.myCustomConfig.mallType == 2 &&
                                      scope.row.statusStr.key !== "unPaid" &&
                                      scope.row.printStatus == 1 &&
                                      scope.row.orderStatus == 0 &&
                                      scope.row.payStatus == true
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.tagPrintStatus(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("标记为打印中")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.canPrintOrder
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.onOrderPrint(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("打印小票")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1820120160
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑订单",
            visible: _vm.dialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("zb-parser", {
                attrs: {
                  "form-id": 104,
                  "is-create": _vm.isCreate,
                  "edit-data": _vm.editData,
                },
                on: { submit: _vm.handlerSubmit, resetForm: _vm.resetForm },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作记录",
            visible: _vm.dialogVisibleJI,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleJI = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.LogLoading,
                  expression: "LogLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { border: true, border: "", data: _vm.tableDataLog.data },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "oid",
                  align: "center",
                  label: "ID",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "changeMessage",
                  label: "操作记录",
                  align: "center",
                  "min-width": "280",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "operateTime",
                  label: "操作时间",
                  align: "center",
                  "min-width": "280",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.tableFromLog.limit,
                  "current-page": _vm.tableFromLog.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableDataLog.total,
                },
                on: {
                  "size-change": _vm.handleSizeChangeLog,
                  "current-change": _vm.pageChangeLog,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "利润计算",
            visible: _vm.shucaipifaDialogVisible,
            width: "1300px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.shucaipifaDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "btn-group-top",
              staticStyle: { "margin-bottom": "15px", "text-align": "right" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success", size: "small" },
                  on: { click: _vm.exportDynamicProfitAndPurchase },
                },
                [_vm._v("\n          导出动态利润&进货数据\n        ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.calculateTotalProfit },
                },
                [_vm._v("\n          计算今日总利润\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "profit-result" }, [
            _vm._v(
              "\n        今日总利润：¥" +
                _vm._s(_vm.totalProfit.toFixed(2)) +
                " 元\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "food-list" },
            _vm._l(_vm.saleInfo, function (item, index) {
              return _c("div", { key: index, staticClass: "food-item" }, [
                _c("h3", [
                  _vm._v(
                    "\n            " +
                      _vm._s(item.product_name || "未知商品") +
                      "\n            "
                  ),
                  _c("span", { staticClass: "food-profit" }, [
                    _vm._v("利润：¥" + _vm._s((item.profit || 0).toFixed(2))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-group" }, [
                  _c("label", [
                    _vm._v(
                      "销售单价 (元/" + _vm._s(item.unit_name || "斤") + ")"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "readonly-text" }, [
                    _vm._v(
                      _vm._s(Number(item.unit_price || 0).toFixed(2)) +
                        " 元/" +
                        _vm._s(item.unit_name || "斤")
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-group" }, [
                  _c("label", [_vm._v("销售数量")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "readonly-text" }, [
                    _vm._v(
                      _vm._s(Number(item.sales_num || 0).toFixed(0)) +
                        " " +
                        _vm._s(item.unit_name || "斤")
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("label", [
                      _vm._v(
                        "成本单价 (元/" + _vm._s(item.unit_name || "斤") + ") *"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "number",
                        step: "0.01",
                        min: "0",
                        placeholder: "请输入成本单价",
                        size: "small",
                      },
                      model: {
                        value: item.inputCost,
                        callback: function ($$v) {
                          _vm.$set(item, "inputCost", _vm._n($$v))
                        },
                        expression: "item.inputCost",
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.shucaipifaDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("details-from", {
        ref: "orderDetail",
        attrs: { orderId: _vm.orderId },
      }),
      _vm._v(" "),
      _c("order-send", {
        ref: "send",
        attrs: { orderId: _vm.orderId },
        on: { submitFail: _vm.getList },
      }),
      _vm._v(" "),
      _c("update-express-num", {
        ref: "updateExpressNum",
        attrs: { orderId: _vm.orderId },
        on: { submitFail: _vm.getList },
      }),
      _vm._v(" "),
      _c("order-video-send", {
        ref: "videoSend",
        attrs: { orderId: _vm.orderId },
        on: { submitFail: _vm.getList },
      }),
      _vm._v(" "),
      _vm.RefuseVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "拒绝退款原因",
                visible: _vm.RefuseVisible,
                width: "500px",
                "before-close": _vm.RefusehandleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.RefuseVisible = $event
                },
              },
            },
            [
              _c("zb-parser", {
                attrs: {
                  "form-id": 106,
                  "is-create": 1,
                  "edit-data": _vm.RefuseData,
                },
                on: {
                  submit: _vm.RefusehandlerSubmit,
                  resetForm: _vm.resetFormRefusehand,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款处理",
            visible: _vm.refundVisible,
            width: "500px",
            "before-close": _vm.refundhandleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.refundVisible = $event
            },
          },
        },
        [
          _vm.refundOrderInfo.bizType == 3
            ? _c("div", [
                _c("div", { staticClass: "wrapper borRadius14" }, [
                  _c("div", { staticClass: "item acea-row row-between" }, [
                    _c("div", [_vm._v("租赁日期：")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "conter" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.refundOrderInfo.leaseOrderInfo.startDate) +
                          " 至 " +
                          _vm._s(_vm.refundOrderInfo.leaseOrderInfo.endDate) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item acea-row row-between" }, [
                    _c("div", [_vm._v("租赁天数：")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "conter" }, [
                      _vm._v(
                        _vm._s(_vm.refundOrderInfo.leaseOrderInfo.days) + "天"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item acea-row row-between" }, [
                    _c("div", [_vm._v("押金金额：")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "conter" }, [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.refundOrderInfo.leaseOrderInfo.payDepositPrice
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item acea-row row-between" }, [
                    _c("div", [_vm._v("租金总金额：")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "conter" }, [
                      _vm._v(
                        "￥" +
                          _vm._s(_vm.refundOrderInfo.leaseOrderInfo.leasePrice)
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item acea-row row-between" }, [
                    _c("div", [_vm._v("日租金：")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "conter" }, [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.refundOrderInfo.leaseOrderInfo.dayLeasePrice
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item acea-row row-between-wrapper" },
                    [
                      _c("div", [_vm._v("判定状态")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "num", staticStyle: { color: "red" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.refundOrderInfo.judgmentStatusForLeaseBiz
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.refundVisible
            ? _c("zb-parser", {
                attrs: {
                  "form-id": 107,
                  "is-create": 1,
                  "edit-data": _vm.refundData,
                },
                on: {
                  submit: _vm.refundhandlerSubmit,
                  resetForm: _vm.resetFormRefundhandler,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }